import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';




function CriarFilial() {
  const navigate = useNavigate();

  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/filial')

  const [formValue, setFormValue] = useState({
    idFilial: '',
    nomeFilial: '',
    idEscola: '',
    nomeEscola: '',
    login: '',
    senha: '',
    latitude: '',
    longitude: '',
    raio: '',
  });

  const handleSubmit = async (values) => {
    const objForm = ({
      ...formValue,
      idEscola: userLogin.idescola,
      nomeEscola: userLogin.nomeescola
    })
    console.log(objForm)
    values.preventDefault();
    util.isSubmitting()
    const result = await api.registrarFilialApi(objForm);
    result ? toast.success("Criado com sucesso!") && navigate("/area-filial") : null;
    util.isSubmitting()
    
  }

  

  const onChange = (e) => {
      setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };


  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh", minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75 p-2 d-flex align-items-center' style={{borderRadius: '1rem', minWidth: '300px'}}>
          <MDBCardTitle className='text-whitmt-2 mt-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
              <MDBCardBody className='d-flex flex-column align-items-center w-100'>

              
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite o nome da filial' invalid>
                        <MDBInput 
                          wrapperClass='mb-4 w-100' 
                          labelClass='text-white' 
                          label='Nome da filial' id='formControNomeFilial' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeFilial'
                          value={formValue.nomeFilial || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite o identificador da filial' invalid>
                        <MDBInput 
                          wrapperClass='mb-4 w-100' 
                          labelClass='text-white' 
                          label='Identificador' 
                          name='idFilial'
                          id='formControIdFilial' 
                          type='text' 
                          size="lg"
                          value={formValue.idFilial || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                    
                    </div>
                    <div className='d-flex justify-content-between'>
                      <MDBValidationItem style={!userLogin.nomeescola ? {width:'45%'} : {width:'45%', opacity:0.4}} feedback='Por favor digite o nome da escola!' invalid>
                        <MDBInput 
                          wrapperClass='w-100' 
                          labelClass='text-white' 
                          className='bg-dark'
                          label='Nome da Escola' 
                          name='nomeEscola'
                          id='formControNomeEscola' 
                          type='text' 
                          size="lg"
                          value={userLogin.nomeescola ? userLogin.nomeescola : formValue.nomeEscola }
                          required
                          disabled={userLogin.nomeescola}
                          style={{color:"white"}}/>
                          
                        
                      
                      </MDBValidationItem >
                      <MDBValidationItem style={!userLogin.idescola ? {width:'45%'} : {width:'45%', opacity:0.4}} feedback='Por favor digite o identificador da escola' invalid>
                        <MDBInput 
                          wrapperClass='mb-4 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Identificador da escola' id='formControIdEscola' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='idEscola'
                          value={userLogin.idescola ? userLogin.idescola : formValue.idEscola }
                          required
                          minLength={3}
                          disabled={userLogin.idescola}
                          />
                        
                      </MDBValidationItem>
                    </div><div className='d-flex justify-content-between'>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite o login!' invalid>
                        <MDBInput 
                          wrapperClass='w-100' 
                          labelClass='text-white' 
                          label='Login' id='formControLogin' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='login'
                          value={formValue.login || ''}
                          onChange={onChange}
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite sua senha!' invalid>
                        <MDBInput 
                          wrapperClass='mb-4 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Senha' 
                          name='senha'
                          id='formControSenha' 
                          type='password' 
                          size="lg"
                          value={formValue.senha || ''}
                          onChange={onChange}

                          required
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                    </div>
                    <div className='d-flex justify-content-between'>
                      <MDBValidationItem style={{width:'30%'}}>
                        <MDBInput 
                          wrapperClass='w-100' 
                          labelClass='text-white' 
                          label='Latitude' id='formControLatitude' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='latitude'
                          value={formValue.latitude || ''}
                          onChange={onChange}
   
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'30%'}}>
                        <MDBInput 
                          wrapperClass='mb-4 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Longitude' 
                          name='longitude'
                          id='formControLongitude' 
                          type='text' 
                          size="lg"
                          value={formValue.longitude || ''}
                          onChange={onChange}

                     
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                      <MDBValidationItem style={{width:'30%'}}>
                        <MDBInput 
                          wrapperClass='mb-4 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Raio em metros' 
                          name='raio'
                          id='formControRaio' 
                          type='text' 
                          size="lg"
                          value={formValue.raio || ''}
                          onChange={onChange}

                          
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                    </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'  
                        //disabled={formValue.senha.length < 3 || formValue.nomeAdministrador.length < 1 || formValue.login.length < 1}                 
                        >
                        
                        Registrar
                      </MDBBtn>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/area-filial")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarFilial;